var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExerciseVideo = function SvgExerciseVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#exercise-video_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.667 16C1.667 8.084 8.084 1.667 16 1.667S30.333 8.084 30.333 16 23.916 30.333 16 30.333 1.667 23.916 1.667 16",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#exercise-video_svg__b)",
    strokeLinecap: "round",
    d: "M16 1.167C7.808 1.167 1.167 7.807 1.167 16c0 8.192 6.64 14.833 14.833 14.833 8.192 0 14.833-6.64 14.833-14.833 0-8.192-6.64-14.833-14.833-14.833Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#exercise-video_svg__c)",
    fillRule: "evenodd",
    d: "M16.06 10.147c.626.307 1.385.774 2.314 1.346l.088.054c.93.573 1.69 1.04 2.251 1.463.57.43 1.065.904 1.33 1.54a3.78 3.78 0 0 1 0 2.9c-.265.636-.76 1.11-1.33 1.54-.562.423-1.32.89-2.25 1.463l-.089.054c-.929.572-1.688 1.039-2.313 1.346-.63.31-1.284.543-1.973.465a3.43 3.43 0 0 1-2.445-1.495c-.384-.563-.518-1.246-.58-1.973C11 18.127 11 17.199 11 16.049v-.096c0-1.15 0-2.078.062-2.802.063-.727.197-1.41.58-1.973a3.43 3.43 0 0 1 2.446-1.495c.69-.078 1.344.156 1.973.465m-1.75 1.522c.105-.011.331.008.868.272.53.261 1.208.677 2.193 1.283.984.606 1.661 1.024 2.139 1.383.478.36.63.572.688.714.18.43.18.927 0 1.359-.059.141-.21.353-.688.713s-1.155.777-2.14 1.383c-.984.606-1.662 1.022-2.192 1.283-.537.264-.763.284-.867.272a1.43 1.43 0 0 1-1.016-.634c-.085-.126-.185-.382-.24-1.018C13.001 18.051 13 17.209 13 16s0-2.05.055-2.679c.055-.636.155-.892.24-1.018a1.43 1.43 0 0 1 1.016-.634",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "exercise-video_svg__b",
    x1: 1.667,
    x2: 30.348,
    y1: 1.667,
    y2: 30.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "exercise-video_svg__c",
    x1: 16.762,
    x2: 34.098,
    y1: 25.032,
    y2: 9.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "exercise-video_svg__a",
    width: 78.667,
    height: 78.667,
    x: -23.333,
    y: -23.333,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_725_2624"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_725_2624",
    result: "shape"
  })))));
};
export { SvgExerciseVideo as ReactComponent };